import {Observable, throwError as observableThrowError} from 'rxjs';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {UserService} from './user.service';
import {District} from '../models/district/district.model';
import {TokenService} from './token.service';
import {FeatureDto} from '../admin/features/featureDto';
import {ApiClient} from './apiClient';
import {CollectionStatsDto, DatabaseStatsDto, OperationStatsDto, ServerStatusDto} from '../admin/mongo/dtos';

@Injectable()
export class AdminService {
  private baseRoute = '/api/admin';

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.tokenService.getUserToken()?.sidrAdmin ?? false;
  }

  public getMongoServer(): Observable<ServerStatusDto> {
    return this.http.get<ServerStatusDto>(`${this.baseRoute}/mongo/server`);
  }

// Mongo stats
  public getMongoStats(): Observable<DatabaseStatsDto> {
    return this.http.get<DatabaseStatsDto>(`${this.baseRoute}/mongo/stats`);
  }

// Mongo collection stats
  public getMongoCollectionStats(): Observable<CollectionStatsDto[]> {
    return this.http.get<CollectionStatsDto[]>(`${this.baseRoute}/mongo/collection/stats`);
  }

// Mongo collection size
  public getMongoCollectionSize(): Observable<CollectionStatsDto[]> {
    return this.http.get<CollectionStatsDto[]>(`${this.baseRoute}/mongo/collection/size`);
  }

// Mongo operation stats
  public getMongoOperationStats(): Observable<OperationStatsDto> {
    return this.http.get<OperationStatsDto>(`${this.baseRoute}/mongo/operation/stats`);
  }


  public getDistrict(id: string): Observable<District> {
    return this.http.get<District>(this.baseRoute + 'district/' + id);
  }

  public getFeatures(): Observable<FeatureDto[]> {
    return this.http.get<FeatureDto[]>(`${this.baseRoute}/features`);
  }

  public getFeature(id: string): Observable<FeatureDto> {
    return this.http.get<FeatureDto>(`${this.baseRoute}/feature/${id}`);
  }

  public postFeature(feature: FeatureDto): Observable<FeatureDto> {
    return this.http.post<FeatureDto>(`${this.baseRoute}/feature`, feature);
  }

  public updateFeature(feature: FeatureDto): Observable<FeatureDto> {
    return this.http.post<FeatureDto>(`${this.baseRoute}/feature/${feature.id}`, feature);
  }

  public enableFeatureForDistrict(featureId: string, districtId: string): Observable<any> {
    return this.http.post<any>(`${this.baseRoute}/feature/${featureId}/${districtId}`, {});
  }

  public disableFeatureForDistrict(featureId: string, districtId: string): Observable<any> {
    return this.http.delete<any>(`${this.baseRoute}/feature/${featureId}/${districtId}`);
  }

  public getDistricts(): Observable<District[]> {
    return this.http.get<District[]>(`${this.baseRoute}/districts`);
  }

  protected handleError(error: Response) {
    return observableThrowError(error || 'Server error');
  }

  constructor(private http: ApiClient, private userService: UserService, private tokenService: TokenService) {
  }
}
